import { START_MONTH, START_YEAR } from '../constants';
import { parseCohortDate } from './parseCohortDate';
import { resultMonthLabel } from './monthLabel';

export function cohortDateToPlanMonthIndex(
  dateStr,
  planStartYear = START_YEAR,
  planStartMonth0Based = START_MONTH
) {
  const parsed = parseCohortDate(dateStr);
  if (!parsed || !Number.isFinite(parsed.month) || parsed.month < 1 || parsed.month > 12) {
    return null;
  }
  return (
    (parsed.year - planStartYear) * 12 +
    (parsed.month - 1 - planStartMonth0Based) +
    1
  );
}

export function isOldCohortPlanIndex(cohortStart) {
  return cohortStart != null && Number.isFinite(cohortStart) && cohortStart < 1;
}

function marginalAmountsForOldCohort(
  cohort,
  cohortStart,
  numMonths,
  calendarAligned = false
) {
  const amounts = new Array(numMonths).fill(0);
  const periods = [...(cohort.periods || [])].sort((a, b) => a.mob - b.mob);
  const mobToPlanOffset = calendarAligned ? 1 : 0;
  let prevCumulative = 0;
  for (const period of periods) {
    const cumulative = Math.round(Number(period.revenue) || 0);
    const marginal = Math.max(0, cumulative - prevCumulative);
    prevCumulative = cumulative;
    const t = cohortStart + period.mob - mobToPlanOffset;
    if (t >= 0 && t < numMonths) {
      amounts[t] += marginal;
    }
  }
  return amounts;
}

function marketingMonthForOldCohort(cohortStart, cols) {
  if (cohortStart >= 0 && cols[cohortStart]) {
    return cols[cohortStart];
  }
  return resultMonthLabel(cohortStart + 1);
}

export function buildOldCohortRevenueRows(
  cohortSheet,
  numMonths,
  cols = [],
  planStartYear = START_YEAR,
  planStartMonth0Based = START_MONTH,
  calendarAligned = false
) {
  if (!cohortSheet?.cohorts?.length) {
    return [];
  }

  const rows = [];
  cohortSheet.cohorts.forEach((cohort, index) => {
    const cohortStart = cohortDateToPlanMonthIndex(
      cohort.cohortDate,
      planStartYear,
      planStartMonth0Based
    );
    if (!isOldCohortPlanIndex(cohortStart)) {
      return;
    }

    const amounts = marginalAmountsForOldCohort(
      cohort,
      cohortStart,
      numMonths,
      calendarAligned
    );
    if (!amounts.some((value) => value !== 0)) {
      return;
    }

    rows.push({
      cohortLabel: cohort.cohortDate || `Old ${index}`,
      cohortStart,
      marketingMonth: marketingMonthForOldCohort(cohortStart, cols),
      marketingSpend: Math.round(Number(cohort.marketingSpend) || 0),
      amounts,
    });
  });

  return rows;
}

export function mapOldCohortRevenue(
  cohortSheet,
  numMonths,
  planStartYear = START_YEAR,
  planStartMonth0Based = START_MONTH,
  calendarAligned = false
) {
  const revenueOld = new Array(numMonths).fill(0);
  const rows = buildOldCohortRevenueRows(
    cohortSheet,
    numMonths,
    [],
    planStartYear,
    planStartMonth0Based,
    calendarAligned
  );
  for (const row of rows) {
    row.amounts.forEach((value, monthIndex) => {
      revenueOld[monthIndex] += value;
    });
  }
  return revenueOld;
}
